import axios from 'axios';

const API = '/api';

export const api = {
  // Categories
  getCategories: () => axios.get(`${API}/categories`).then(r => r.data),
  getCategory: (slug) => axios.get(`${API}/categories/${slug}`).then(r => r.data),
  
  // Species
  getSpecies: (categoryId) => axios.get(`${API}/species`, { params: { category_id: categoryId } }).then(r => r.data),
  getSpeciesBySlug: (categorySlug) => axios.get(`${API}/taxonomy/species/${categorySlug}`).then(r => r.data),
  
  // Morphs
  getMorphs: (speciesId) => axios.get(`${API}/morphs`, { params: { species_id: speciesId } }).then(r => r.data),
  getMorphsBySpecies: (speciesCanonical) => axios.get(`${API}/taxonomy/morphs/${speciesCanonical}`).then(r => r.data),
  getShippingMethods: () => axios.get(`${API}/taxonomy/shipping-methods`).then(r => r.data),
  
  // Listings
  getListings: (params) => axios.get(`${API}/listings`, { params }).then(r => r.data),
  getListing: (id) => axios.get(`${API}/listings/${id}`).then(r => r.data),
  createListing: (data) => axios.post(`${API}/listings`, data).then(r => r.data),
  updateListing: (id, data) => axios.put(`${API}/listings/${id}`, data).then(r => r.data),
  deleteListing: (id) => axios.delete(`${API}/listings/${id}`).then(r => r.data),
  getMyListings: (status) => axios.get(`${API}/my-listings`, { params: { status } }).then(r => r.data),
  featureListing: (id, originUrl) => axios.post(`${API}/listings/${id}/feature`, null, { params: { origin_url: originUrl } }).then(r => r.data),
  
  // Favorites
  addFavorite: (listingId) => axios.post(`${API}/favorites/${listingId}`).then(r => r.data),
  removeFavorite: (listingId) => axios.delete(`${API}/favorites/${listingId}`).then(r => r.data),
  getFavorites: () => axios.get(`${API}/favorites`).then(r => r.data),
  
  // Messages
  sendMessage: (data) => axios.post(`${API}/messages`, data).then(r => r.data),
  getConversations: () => axios.get(`${API}/conversations`).then(r => r.data),
  getMessages: (conversationId) => axios.get(`${API}/conversations/${conversationId}/messages`).then(r => r.data),
  
  // Reviews
  createReview: (data) => axios.post(`${API}/reviews`, data).then(r => r.data),
  getSellerReviews: (sellerId) => axios.get(`${API}/reviews/${sellerId}`).then(r => r.data),
  
  // Seller
  getSellerProfile: (id) => axios.get(`${API}/sellers/${id}`).then(r => r.data),
  updateSellerProfile: (data) => axios.put(`${API}/seller/profile`, data).then(r => r.data),
  
  // Subscriptions
  getPlans: () => axios.get(`${API}/subscriptions/plans`).then(r => r.data),
  createCheckout: (planId, originUrl, couponCode) => {
    const params = { plan_id: planId, origin_url: originUrl };
    if (couponCode) params.coupon_code = couponCode;
    return axios.post(`${API}/subscriptions/checkout`, null, { params }).then(r => r.data);
  },
  checkSubscriptionStatus: (sessionId) => axios.get(`${API}/subscriptions/status/${sessionId}`).then(r => r.data),
  validateCoupon: (code) => axios.get(`${API}/coupons/validate`, { params: { code } }).then(r => r.data),
  
  // AI
  getAISettings: () => axios.get(`${API}/ai/settings`).then(r => r.data),
  updateAISettings: (data) => axios.put(`${API}/ai/settings`, null, { params: data }).then(r => r.data),
  getAIKnowledge: () => axios.get(`${API}/ai/knowledge`).then(r => r.data),
  addAIKnowledge: (data) => axios.post(`${API}/ai/knowledge`, data).then(r => r.data),
  deleteAIKnowledge: (id) => axios.delete(`${API}/ai/knowledge/${id}`).then(r => r.data),
  chatWithAI: (sellerId, data) => axios.post(`${API}/ai/chat/${sellerId}`, data).then(r => r.data),
  getAIConversations: () => axios.get(`${API}/ai/conversations`).then(r => r.data),
  getAIStats: () => axios.get(`${API}/ai/stats`).then(r => r.data),
  
  // Dashboard
  getDashboardStats: () => axios.get(`${API}/dashboard/stats`).then(r => r.data),
  
  // Upload
  uploadFile: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(r => r.data);
  },
  
  // Admin
  getAdminUsers: (page, limit, search, role, subscription) => axios.get(`${API}/admin/users`, { params: { page, limit, search, role, subscription } }).then(r => r.data),
  updateUserRole: (userId, role) => axios.put(`${API}/admin/users/${userId}/role`, null, { params: { role } }).then(r => r.data),
  suspendUser: (userId, reason) => axios.post(`${API}/admin/users/${userId}/suspend`, { reason }).then(r => r.data),
  reactivateUser: (userId) => axios.post(`${API}/admin/users/${userId}/reactivate`).then(r => r.data),
  deleteUser: (userId) => axios.delete(`${API}/admin/users/${userId}`).then(r => r.data),
  getAdminStats: () => axios.get(`${API}/admin/stats`).then(r => r.data),

  // Admin Categories
  getAdminCategories: () => axios.get(`${API}/admin/categories`).then(r => r.data),
  createCategory: (data) => axios.post(`${API}/categories`, data).then(r => r.data),
  updateCategory: (slug, data) => axios.put(`${API}/admin/categories/${slug}`, data).then(r => r.data),
  deleteCategory: (slug) => axios.delete(`${API}/admin/categories/${slug}`).then(r => r.data),

  // Notifications
  getNotifications: (unread_only = false) => axios.get(`${API}/notifications`, { params: { unread_only } }).then(r => r.data),
  markNotificationRead: (id) => axios.put(`${API}/notifications/${id}/read`).then(r => r.data),
  markAllNotificationsRead: () => axios.put(`${API}/notifications/read-all`).then(r => r.data),

  // Billing
  getBillingStatus: () => axios.get(`${API}/billing/status`).then(r => r.data),
  getBillingHistory: () => axios.get(`${API}/billing/history`).then(r => r.data),

  // Reputation & Reviews (bidirectional)
  getReputation: (userId) => axios.get(`${API}/reputation/${userId}`).then(r => r.data),
  getUserReviews: (userId, type) => axios.get(`${API}/reviews/user/${userId}`, { params: { review_type: type } }).then(r => r.data),

  // Badges
  getUserBadges: (userId) => axios.get(`${API}/badges/${userId}`).then(r => r.data),
  checkBadgeEligibility: (userId) => axios.get(`${API}/badges/check/${userId}`).then(r => r.data),
  adminGrantBadge: (data) => axios.post(`${API}/admin/badges/grant`, data).then(r => r.data),
  adminRevokeBadge: (data) => axios.post(`${API}/admin/badges/revoke`, data).then(r => r.data),

  // Strikes
  getMyStrikes: () => axios.get(`${API}/strikes/me`).then(r => r.data),
  adminIssueStrike: (data) => axios.post(`${API}/admin/strikes`, data).then(r => r.data),
  adminGetStrikes: (userId, status) => axios.get(`${API}/admin/strikes`, { params: { user_id: userId, status } }).then(r => r.data),
  adminResolveStrike: (strikeId) => axios.put(`${API}/admin/strikes/${strikeId}/resolve`).then(r => r.data),

  // Reports
  createReport: (data) => axios.post(`${API}/reports`, data).then(r => r.data),
  adminGetReports: (status) => axios.get(`${API}/admin/reports`, { params: { status } }).then(r => r.data),

  // Auth - Extended
  forgotPassword: (email) => axios.post(`${API}/auth/forgot-password`, { email }).then(r => r.data),
  resetPassword: (token, new_password) => axios.post(`${API}/auth/reset-password`, { token, new_password }).then(r => r.data),
  changePassword: (current_password, new_password) => axios.post(`${API}/auth/change-password`, { current_password, new_password }).then(r => r.data),

  // Email
  testEmail: (template, to) => axios.post(`${API}/email/test`, { template, to }).then(r => r.data),
  listEmailTemplates: () => axios.get(`${API}/email/templates`).then(r => r.data),

  // Commitments
  recordCommitment: (data) => axios.post(`${API}/commitments`, data).then(r => r.data),
  checkCommitment: (listingId, auctionId) => axios.get(`${API}/commitments/check`, { params: { listing_id: listingId, auction_id: auctionId } }).then(r => r.data),
  getCommitmentTexts: () => axios.get(`${API}/commitments/texts`).then(r => r.data),
  getCommitmentText: (actionType) => axios.get(`${API}/commitments/text/${actionType}`).then(r => r.data),

  // Auctions
  getAuctions: (params) => axios.get(`${API}/auctions`, { params }).then(r => r.data),
  getAuction: (id) => axios.get(`${API}/auctions/${id}`).then(r => r.data),
  createAuction: (data) => axios.post(`${API}/auctions`, data).then(r => r.data),
  getMyAuctions: (status) => axios.get(`${API}/auctions/seller/mine`, { params: { status } }).then(r => r.data),
  placeBid: (auctionId, data) => axios.post(`${API}/auctions/${auctionId}/bid`, data).then(r => r.data),
  endAuction: (auctionId) => axios.post(`${API}/auctions/${auctionId}/end`).then(r => r.data),
  confirmAuctionPayment: (auctionId) => axios.post(`${API}/auctions/${auctionId}/confirm-payment`).then(r => r.data),
  confirmAuctionShipped: (auctionId) => axios.post(`${API}/auctions/${auctionId}/confirm-shipped`).then(r => r.data),
  completeAuction: (auctionId) => axios.post(`${API}/auctions/${auctionId}/complete`).then(r => r.data),
  cancelAuction: (auctionId, reason) => axios.post(`${API}/auctions/${auctionId}/cancel`, null, { params: { reason } }).then(r => r.data),
  toggleWatchAuction: (auctionId) => axios.post(`${API}/auctions/${auctionId}/watch`).then(r => r.data),

  // Protected Purchase (Compra Protegida)
  startConnectOnboarding: (origin_url) => axios.post(`${API}/connect/onboard`, { origin_url }).then(r => r.data),
  getConnectStatus: () => axios.get(`${API}/connect/status`).then(r => r.data),
  getConnectDashboard: () => axios.get(`${API}/connect/dashboard-link`).then(r => r.data),
  createProtectedPurchase: (data) => axios.post(`${API}/protected-purchase/create`, data).then(r => r.data),
  getProtectedPurchaseStatus: (sessionId) => axios.get(`${API}/protected-purchase/status/${sessionId}`).then(r => r.data),
  getProtectedPurchase: (txId) => axios.get(`${API}/protected-purchase/${txId}`).then(r => r.data),
  getMyPurchases: () => axios.get(`${API}/protected-purchase/my/buyer`).then(r => r.data),
  getMySales: () => axios.get(`${API}/protected-purchase/my/seller`).then(r => r.data),
  markShipped: (txId) => axios.post(`${API}/protected-purchase/${txId}/ship`).then(r => r.data),
  confirmDelivery: (txId) => axios.post(`${API}/protected-purchase/${txId}/confirm-delivery`).then(r => r.data),
  openDispute: (txId, data) => axios.post(`${API}/protected-purchase/${txId}/dispute`, data).then(r => r.data),

  // Subscription Waitlist
  joinSubscriptionWaitlist: (data) => axios.post(`${API}/waitlist`, data).then(r => r.data),
  getSubscriptionWaitlistCount: (planId) => axios.get(`${API}/waitlist/count/${planId}`).then(r => r.data),

  // Compliance
  getComplianceRules: (categorySlug) => axios.get(`${API}/compliance/rules/${categorySlug}`).then(r => r.data),
  getAllComplianceRules: () => axios.get(`${API}/compliance/rules`).then(r => r.data),
  uploadLegalDoc: (listingId, data) => axios.post(`${API}/listings/${listingId}/legal-docs`, data).then(r => r.data),
  getLegalDocs: (listingId) => axios.get(`${API}/listings/${listingId}/legal-docs`).then(r => r.data),
  submitLegalDeclaration: (listingId, data) => axios.post(`${API}/listings/${listingId}/legal-declaration`, data).then(r => r.data),
  flagListing: (listingId, reason) => axios.post(`${API}/compliance/flag/${listingId}`, null, { params: { reason } }).then(r => r.data),
  getComplianceProfile: () => axios.get(`${API}/compliance/profile`).then(r => r.data),

  // Legal Consent
  recordConsent: (data) => axios.post(`${API}/legal/consent`, data).then(r => r.data),
  getMyConsents: () => axios.get(`${API}/legal/consents`).then(r => r.data),
  checkSellerConsents: () => axios.get(`${API}/legal/consent-check`).then(r => r.data),
  getTermsVersion: () => axios.get(`${API}/legal/terms-version`).then(r => r.data),

  // Admin Morph Review
  getAdminMorphs: (params) => axios.get(`${API}/admin/morphs`, { params }).then(r => r.data),
  updateMorphStatus: (speciesCanonical, morphCanonical, body) =>
    axios.put(`${API}/admin/morphs/${speciesCanonical}/${morphCanonical}`, body).then(r => r.data),

  // Enbixos
  getEnbixosConfig: () => axios.get(`${API}/enbixos/config`).then(r => r.data),
  updateEnbixosConfig: (data) => axios.put(`${API}/enbixos/config`, data).then(r => r.data),
  createShippingRequest: (data) => axios.post(`${API}/enbixos/requests`, data).then(r => r.data),
  getShippingRequests: (params) => axios.get(`${API}/enbixos/requests`, { params }).then(r => r.data),
  getShippingRequest: (id) => axios.get(`${API}/enbixos/requests/${id}`).then(r => r.data),
  uploadShippingReceipt: (id, data) => axios.post(`${API}/enbixos/requests/${id}/receipt`, data).then(r => r.data),
  updateShippingStatus: (id, data) => axios.put(`${API}/enbixos/requests/${id}/status`, data).then(r => r.data),
  addShippingNote: (id, data) => axios.post(`${API}/enbixos/requests/${id}/notes`, data).then(r => r.data),
  assignShippingRoute: (data) => axios.post(`${API}/enbixos/requests/assign-route`, data).then(r => r.data),
  getEnbixosRoutes: () => axios.get(`${API}/enbixos/routes`).then(r => r.data),
  getNextEnbixosRoute: () => axios.get(`${API}/enbixos/routes/next`).then(r => r.data),
  createEnbixosRoute: (data) => axios.post(`${API}/enbixos/routes`, data).then(r => r.data),
  updateEnbixosRoute: (id, data) => axios.put(`${API}/enbixos/routes/${id}`, data).then(r => r.data),
  getEnbixosNotifications: (unreadOnly) => axios.get(`${API}/enbixos/notifications`, { params: { unread_only: unreadOnly } }).then(r => r.data),
  markEnbixosNotifRead: (id) => axios.put(`${API}/enbixos/notifications/${id}/read`).then(r => r.data),

  // Clutches / Pre-sale
  createClutch: (data) => axios.post(`${API}/clutches`, data).then(r => r.data),
  getClutches: (params) => axios.get(`${API}/clutches`, { params }).then(r => r.data),
  getClutch: (id) => axios.get(`${API}/clutches/${id}`).then(r => r.data),
  updateClutch: (id, data) => axios.put(`${API}/clutches/${id}`, data).then(r => r.data),
  updateClutchStatus: (id, status) => axios.put(`${API}/clutches/${id}/status`, { status }).then(r => r.data),
  joinClutchWaitlist: (clutchId, data) => axios.post(`${API}/clutches/${clutchId}/waitlist`, data).then(r => r.data),
  getClutchWaitlist: (clutchId) => axios.get(`${API}/clutches/${clutchId}/waitlist`).then(r => r.data),
  reorderClutchWaitlist: (clutchId, ids) => axios.put(`${API}/clutches/${clutchId}/waitlist/reorder`, { waitlist_ids: ids }).then(r => r.data),
  removeFromClutchWaitlist: (clutchId, wlId) => axios.delete(`${API}/clutches/${clutchId}/waitlist/${wlId}`).then(r => r.data),
  createClutchDeposit: (clutchId, data) => axios.post(`${API}/clutches/${clutchId}/deposit`, data).then(r => r.data),
  recordHatch: (clutchId, data) => axios.post(`${API}/clutches/${clutchId}/hatch`, data).then(r => r.data),
  assignOffspring: (clutchId, data) => axios.post(`${API}/clutches/${clutchId}/assign`, data).then(r => r.data),
  convertToListings: (clutchId) => axios.post(`${API}/clutches/${clutchId}/convert-to-listings`).then(r => r.data),
  getMyClutches: (params) => axios.get(`${API}/clutches/my/list`, { params }).then(r => r.data),
  getMyWaitlists: () => axios.get(`${API}/clutches/my/waitlists`).then(r => r.data),

  // WhatsApp post-compra
  getWhatsAppContact: (orderType, orderId) => axios.get(`${API}/whatsapp/contact/${orderType}/${orderId}`).then(r => r.data),
  getWhatsAppAnalytics: () => axios.get(`${API}/whatsapp/analytics`).then(r => r.data),

  // Admin - Demo cleanup
  getDemoCount: () => axios.get(`${API}/admin/demo-listings/count`).then(r => r.data),
  cleanupDemos: () => axios.delete(`${API}/admin/demo-listings`).then(r => r.data),
  adminActivateAI: (userId, planId) => axios.post(`${API}/admin/activate-ai/${userId}`, { plan_id: planId }).then(r => r.data),

  // Admin - Mission Control
  adminDashboard: () => axios.get(`${API}/admin/dashboard`).then(r => r.data),
  adminAlerts: () => axios.get(`${API}/admin/alerts`).then(r => r.data),
  adminActivity: (limit) => axios.get(`${API}/admin/activity`, { params: { limit } }).then(r => r.data),
  adminHealth: () => axios.get(`${API}/admin/health`).then(r => r.data),
  adminAIMonitoring: () => axios.get(`${API}/admin/ai`).then(r => r.data),
  adminQuickStats: () => axios.get(`${API}/admin/quick-stats`).then(r => r.data),
  adminResetAICounter: (userId) => axios.post(`${API}/admin/ai/reset-counter/${userId}`).then(r => r.data),
  adminToggleAI: (userId, data) => axios.post(`${API}/admin/ai/toggle/${userId}`, data).then(r => r.data),
  adminGetUsers: (params) => axios.get(`${API}/admin/users`, { params }).then(r => r.data),
  adminSuspendUser: (userId, data) => axios.post(`${API}/admin/users/${userId}/suspend`, data).then(r => r.data),
  adminReactivateUser: (userId) => axios.post(`${API}/admin/users/${userId}/reactivate`).then(r => r.data),
  adminGetListings: (params) => axios.get(`${API}/admin/listings`, { params }).then(r => r.data),
  adminUpdateListingStatus: (listingId, data) => axios.put(`${API}/admin/listings/${listingId}/status`, data).then(r => r.data),
  adminDeleteListing: (listingId, data) => axios.delete(`${API}/admin/listings/${listingId}`, { data }).then(r => r.data),
  adminSubscriptions: (params) => axios.get(`${API}/admin/subscriptions`, { params }).then(r => r.data),
  adminChangePlan: (userId, data) => axios.post(`${API}/admin/subscriptions/${userId}/change-plan`, data).then(r => r.data),

  // Admin - Message Surveillance
  adminUserConversations: (userId) => axios.get(`${API}/admin/users/${userId}/conversations`).then(r => r.data),
  adminGetMessages: (userId, partnerId, page) => axios.get(`${API}/admin/messages/${userId}/${partnerId}`, { params: { page } }).then(r => r.data),

  // Admin - View As
  adminViewAs: (userId) => axios.post(`${API}/admin/view-as/${userId}`).then(r => r.data),

  // Support Tickets (User)
  createTicket: (data) => axios.post(`${API}/support/tickets`, data).then(r => r.data),
  getMyTickets: (status) => axios.get(`${API}/support/tickets`, { params: { status } }).then(r => r.data),
  getTicket: (id) => axios.get(`${API}/support/tickets/${id}`).then(r => r.data),
  replyTicket: (id, data) => axios.post(`${API}/support/tickets/${id}/reply`, data).then(r => r.data),
  closeTicket: (id) => axios.put(`${API}/support/tickets/${id}/close`).then(r => r.data),

  // Support Tickets (Admin)
  adminListTickets: (params) => axios.get(`${API}/admin/support/tickets`, { params }).then(r => r.data),
  adminChangeTicketStatus: (id, data) => axios.put(`${API}/admin/support/tickets/${id}/status`, data).then(r => r.data),
  adminChangeTicketPriority: (id, data) => axios.put(`${API}/admin/support/tickets/${id}/priority`, data).then(r => r.data),

  // Admin - Auctions
  adminListAuctions: (params) => axios.get(`${API}/admin/auctions`, { params }).then(r => r.data),
  adminNotificationCounts: () => axios.get(`${API}/admin/notifications/counts`).then(r => r.data),
  adminCancelAuction: (id, data) => axios.post(`${API}/admin/auctions/${id}/cancel`, data).then(r => r.data),
  adminAuctionConfig: (data) => axios.put(`${API}/admin/auctions/config`, data).then(r => r.data),
  adminFraudEvents: (params) => axios.get(`${API}/admin/auctions/fraud-events`, { params }).then(r => r.data),
  adminResolveFraud: (id, data) => axios.post(`${API}/admin/auctions/${id}/resolve-fraud`, data).then(r => r.data),

  // Admin - Enbixos
  adminListEnbixos: (params) => axios.get(`${API}/admin/enbixos/requests`, { params }).then(r => r.data),

  // Admin - Compliance
  adminComplianceOverview: () => axios.get(`${API}/admin/compliance/overview`).then(r => r.data),
  adminComplianceDocs: (params) => axios.get(`${API}/admin/compliance/docs`, { params }).then(r => r.data),
  adminCompliancePending: () => axios.get(`${API}/admin/compliance/pending`).then(r => r.data),
  adminReviewDoc: (docId, data) => axios.put(`${API}/admin/compliance/review-doc/${docId}`, null, { params: data }).then(r => r.data),
  adminReviewListing: (listingId, data) => axios.put(`${API}/admin/compliance/review-listing/${listingId}`, null, { params: data }).then(r => r.data),
  adminRestrictedSpecies: () => axios.get(`${API}/admin/compliance/restricted-species`).then(r => r.data),
  adminAddRestriction: (data) => axios.post(`${API}/admin/compliance/species-restriction`, data).then(r => r.data),
};

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (!detail) return error?.message || 'Algo salió mal';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(' ');
  if (detail?.msg) return detail.msg;
  return String(detail);
}
